import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';
import { ADDENDUM_IN_PROGRESS } from '../../../../../constants/reports';
import { formatDate } from '../../../../../utils/formatters';

const UnpaidTransactionReportTableRow = ({ rowData, id }) => {
  const {
    contractNumber,
    totalContractValue,
    dueAmount,
    dueType,
    contractType,
    location,
    arranger,
    createdDate,
    submissionDate,
    lastPaymentDate,
    lastPaymentAmount,
    lastScheduledPayDate,
    financingTerm,
    repaymentNumber,
    payorDetails,
    day30,
    day60,
    day90,
    day120,
    above120,
    addendumStatus,
  } = rowData;

  return (
    <tr key={id} className="unpaid-tr">
      <td>
        {contractNumber || '-'}
        {addendumStatus === ADDENDUM_IN_PROGRESS && (
          <p className="addendum-note">Note: Addendum In Progress</p>
        )}
      </td>
      <td>{totalContractValue ? getPrice(totalContractValue) : '-'}</td>
      <td>{getPrice(dueAmount)}</td>
      <td>
        <span className={dueType === 'Past Due' ? 'due-td' : 'due-td-1'}>{dueType || '-'}</span>
      </td>
      <td>{contractType || '-'}</td>
      <td>{location || '-'}</td>
      <td>{arranger || '-'}</td>
      <td>{formatDate(createdDate)}</td>
      <td>{formatDate(submissionDate)}</td>
      <td>
        {formatDate(lastPaymentDate)}
        {lastPaymentAmount ? ` (${getPrice(lastPaymentAmount)})` : ''}
      </td>
      <td>{formatDate(lastScheduledPayDate)}</td>
      <td>
        {financingTerm && repaymentNumber
          ? `${financingTerm} (${repaymentNumber})`
          : financingTerm || repaymentNumber || '-'}
      </td>
      <td>{payorDetails || '-'}</td>
      <td>{getPrice(day30)}</td>
      <td>{getPrice(day60)}</td>
      <td>{getPrice(day90)}</td>
      <td>{getPrice(day120)}</td>
      <td>{getPrice(above120)}</td>
    </tr>
  );
};

UnpaidTransactionReportTableRow.propTypes = {
  rowData: PropTypes.shape({
    location: PropTypes.string,
    contractNumber: PropTypes.string,
    totalContractValue: PropTypes.number,
    dueAmount: PropTypes.number,
    dueType: PropTypes.string,
    contractType: PropTypes.string,
    arranger: PropTypes.string,
    createdDate: PropTypes.string,
    submissionDate: PropTypes.string,
    lastPaymentDate: PropTypes.string,
    lastPaymentAmount: PropTypes.number,
    lastScheduledPayDate: PropTypes.string,
    financingTerm: PropTypes.string,
    repaymentNumber: PropTypes.string,
    payorDetails: PropTypes.string,
    day30: PropTypes.number,
    day60: PropTypes.number,
    day90: PropTypes.number,
    day120: PropTypes.number,
    above120: PropTypes.number,
    dueDays: PropTypes.string,
    extraInstalmentAmountPaid: PropTypes.number,
    addendumStatus: PropTypes.string,
  }).isRequired,
  id: PropTypes.number.isRequired,
};

export default UnpaidTransactionReportTableRow;
